"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addData = exports.trackEvent = exports.init = void 0;

/**
 * Generic key-value payload object.
 */
var dataLayer;
/**
 * Use the provided array as the initial data layer.
 */

var init = function init(initialDataLayer) {
  dataLayer = initialDataLayer;
};
/**
 * Fire an event with the provided name and optional payload.
 */


exports.init = init;

var trackEvent = function trackEvent(eventName) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = {
    event: eventName
  };
  Object.keys(payload).forEach(function (key) {
    message["".concat(eventName, ".").concat(key)] = payload[key];
  });
  dataLayer.push(message);
};
/**
 * Make all fields in the payload available in the data layer.
 */


exports.trackEvent = trackEvent;

var addData = function addData(payload) {
  dataLayer.push(payload);
};

exports.addData = addData;